export const environment = {
  production: false,
  proxyBaseUrl: 'https://qct.nccourts.org/ciprs_proxy_ws_1_1_0/rest/v1/',
  criminalApplicationUrl: 'https://cisptlt.nccourts.org/ciprsweb/civilstyle/',
  estateBaseUrl: 'TBD',
  sessionTimeout: '60',  // 60 minutes
  security: {
    client_id: 'fc5be1a8-c7b8-46ee-9d48-c8b2d21e96e4',
    redirect_uri: '/auth.html',
    client_certificate_auth_uri: 'https://cisptlf.nccourts.org:30443/aas/oauth/authorize',
    auth_uri: 'https://qct.nccourts.org/oauth/authorize',
    check_token_uri: 'https://qct.nccourts.org/oauth/v2/check_token_with_state',
    revoke_token_uri: 'https://qct.nccourts.org/oauth/revoke_token',
  }
};



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/environments/environment.fields.ts